import * as Sentry from "@sentry/react";
import { useEffect } from "react";

import { RootState, useAppSelector } from "@/redux/store";

export const useSentryScope = (): void => {
  const userData = useAppSelector((state) => state.user?.userData);
  const workspaceData = useAppSelector(
    (state: RootState) => state.user?.workspaceData,
  );

  useEffect(() => {
    if (!userData) {
      Sentry.setUser(null);
      Sentry.setContext("user", null);

      return;
    }

    const username =
      [userData.firstName, userData.lastName].filter(Boolean).join(" ") ||
      userData.email ||
      "unknown-user";

    Sentry.setUser({
      email: userData.email ?? undefined,
      username,
    });

    Sentry.setContext("user", {
      username,
      role: userData.role ?? "unknown-role",
    });
  }, [userData]);

  useEffect(() => {
    if (!workspaceData) {
      Sentry.setContext("workspace", null);
      Sentry.setTag("workspace.name", "unknown-workspace");

      return;
    }

    const workspaceName = workspaceData.name ?? "unknown-workspace";

    Sentry.setTag("workspace.name", workspaceName);
    Sentry.setContext("workspace", {
      name: workspaceName,
    });
  }, [workspaceData]);
};
